module.exports = __webpack_public_path__ + "static/media/apartment5.7d18fd7e.png";